import { PAYMENT_TYPE_CODE } from '@/domains/BillPaymentDomain'
import {
  BILL_PAYMENT_LANDING_SCHEME,
  BILL_PAYMENT_ROUTES,
  DEBIT_CARD_LANDING_SCHEME,
  SCHEDULE_PAYMENT_LANDING_SCHEME,
  SCHEDULE_PAYMENT_ROUTES,
} from '@/domains/CommonDomain'

const checkLandingScheme = (landingScheme: string) => (path: string) => landingScheme.includes(path)
const replaceLandingScheme = (landingScheme: string) => (from: string, to: string) =>
  landingScheme.replace(from, to)

export const landingRoute = (landingScheme: string) => {
  const checkPath = checkLandingScheme(landingScheme)
  const replacePath = replaceLandingScheme(landingScheme)
  const isDebitCard = checkPath(DEBIT_CARD_LANDING_SCHEME.ROOT)
  const isSchedulePayment = checkPath(SCHEDULE_PAYMENT_LANDING_SCHEME.ROOT)
  const isBillPayment = checkPath(BILL_PAYMENT_LANDING_SCHEME.ROOT)
  let route = landingScheme

  if (isSchedulePayment) {
    if (checkPath(SCHEDULE_PAYMENT_LANDING_SCHEME.DETAIL)) {
      route = replacePath(SCHEDULE_PAYMENT_LANDING_SCHEME.DETAIL, SCHEDULE_PAYMENT_ROUTES.DETAIL)
    } else if (checkPath(SCHEDULE_PAYMENT_LANDING_SCHEME.HISTORY)) {
      route = replacePath(SCHEDULE_PAYMENT_LANDING_SCHEME.HISTORY, SCHEDULE_PAYMENT_ROUTES.HISTORY)
    } else if (checkPath(SCHEDULE_PAYMENT_LANDING_SCHEME.HISTORY_DETAIL)) {
      route = replacePath(
        SCHEDULE_PAYMENT_LANDING_SCHEME.HISTORY_DETAIL,
        SCHEDULE_PAYMENT_ROUTES.HISTORY_DETAIL,
      )
    } else if (checkPath(SCHEDULE_PAYMENT_LANDING_SCHEME.SEND)) {
      route = replacePath(SCHEDULE_PAYMENT_LANDING_SCHEME.SEND, SCHEDULE_PAYMENT_ROUTES.SEND)
    } else {
      route = replacePath(SCHEDULE_PAYMENT_LANDING_SCHEME.ROOT, SCHEDULE_PAYMENT_ROUTES.ROOT)
    }
  }

  if (isBillPayment) {
    if (checkPath(BILL_PAYMENT_LANDING_SCHEME.PULSA)) {
      route = replacePath(
        BILL_PAYMENT_LANDING_SCHEME.PULSA,
        `${BILL_PAYMENT_ROUTES.PRODUCT_GROUP}/${PAYMENT_TYPE_CODE.PULSA}`,
      )
    } else if (checkPath(BILL_PAYMENT_LANDING_SCHEME.BILLS)) {
      route = replacePath(
        BILL_PAYMENT_LANDING_SCHEME.BILLS,
        `${BILL_PAYMENT_ROUTES.PRODUCT_GROUP}/${PAYMENT_TYPE_CODE.BILLS}`,
      )
    } else {
      route = replacePath(BILL_PAYMENT_LANDING_SCHEME.ROOT, BILL_PAYMENT_ROUTES.ROOT)
    }
  }

  return {
    isDebitCard,
    isSchedulePayment,
    isBillPayment,
    route,
  }
}
